export enum OrderEnum {
  ASC = '0',
  DESC = '1',
}
